import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const AddStagesAction = createAsyncThunk(
  "dropdowns/AddStagess",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ReportsStages/AddReportsStages",
        Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetListReportsStagesByApplicationInformationGUID =
  createAsyncThunk(
    "dropdowns/GetListReportsStages",
    async (Parameter, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/PR_ReportsStages/GetListReportsStagesByApplicationInformationGUID",
          Parameter
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const GetLengthReportsStages = createAsyncThunk(
  "dropdowns/GetLengthReportsStages",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ReportsStages/GetLengthReportsStages",
        Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteReportsStages = createAsyncThunk(
  "dropdowns/DeleteReportsStages",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ReportsStages/DeleteReportsStages",
        Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetReportStageByID = createAsyncThunk(
  "PR_ReportsStages/GetReportStageByID",
  async (reportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ReportsStages/GetReportStageByID",
        {
          reportsStagesGuid: reportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllStagesByReportId = createAsyncThunk(
  "DropDowns/GetAllStagesByReportId",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/DropDowns/GetAllStagesByReportId?ReportId=${param}`
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetCurrentStageFromReport = createAsyncThunk(
  "DropDowns/GetCurrentStageFromReport",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/PR_ReportsStages/GetCurrentStageFromReport`,
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetListReportsStagesByAP_ApplicationInformationGUIDTotalTime =
  createAsyncThunk(
    "DropDowns/GetListReportsStagesByAP_ApplicationInformationGUIDTotalTime",
    async (param, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          `api/PR_ReportsStages/GetListReportsStagesByAP_ApplicationInformationGUIDTotalTime`,
          param
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
const Stages = createSlice({
  name: "TypeOfJobOpportunityDropDown",
  initialState: {
    AddStages: [],
    loadingAddStages: false,
    errorAddStages: null,

    // --------------------------------------------------------

    ListReportsStages: [],
    loadingListReportsStages: false,
    errorListReportsStages: null,
    // --------------------------------------------------------
    LengthReportsStages: [],
    loadingLengthReportsStages: false,
    errorLengthReportsStages: null,
    // --------------------------------------------------------
    deletReportsStages: [],
    loadingdeletReportsStages: false,
    errordeletReportsStages: null,
    // --------------------------------------------------------
    ReportsStagesById: [],
    loadingReportsStagesById: false,
    errorReportsStagesById: null,
    // -------------------GetAllStagesByReportId-------------------------------------
    ReportsStagesDropDownList: [],
    loadingReportsStagesDropDownList: false,
    errorReportsStagesDropDownList: null,
    // -------------------CurrentStage-------------------------------------
    CurrentStage: [],
    loadingCurrentStage: false,
    errorCurrentStage: null,
    //---------------------------------------------------------------
    CurrentStageInfo:{},
    loadingCurrentStageInfo: false,
    errorCurrentStageInfo: null,

    reportStageGuid: "",
  },
  reducers: {
    SetreportStageGuid: (state, action) => {
      state.reportStageGuid = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AddStagesAction.pending, (state, action) => {
        state.loadingAddStages = true;
        state.AddStages = action.payload;
        state.errorAddStages = null;
      })
      .addCase(AddStagesAction.fulfilled, (state, action) => {
        state.loadingAddStages = false;
        state.AddStages = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddStagesAction.rejected, (state, action) => {
        state.loadingAddStages = false;
        state.errorAddStages = action.payload;
      });
    // --------------------------------------------------------

    builder
      .addCase(
        GetListReportsStagesByApplicationInformationGUID.pending,
        (state, action) => {
          state.loadingListReportsStages = true;
          state.ListReportsStages = action.payload;
          state.errorListReportsStages = null;
        }
      )
      .addCase(
        GetListReportsStagesByApplicationInformationGUID.fulfilled,
        (state, action) => {
          state.loadingListReportsStages = false;
          state.ListReportsStages = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetListReportsStagesByApplicationInformationGUID.rejected,
        (state, action) => {
          state.loadingListReportsStages = false;
          state.errorListReportsStages = action.payload;
        }
      );
    // --------------------------------------------------------
    builder
      .addCase(GetLengthReportsStages.pending, (state, action) => {
        state.loadingLengthReportsStages = true;
        state.LengthReportsStages = action.payload;
        state.errorLengthReportsStages = null;
      })
      .addCase(GetLengthReportsStages.fulfilled, (state, action) => {
        state.loadingLengthReportsStages = false;
        state.LengthReportsStages = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetLengthReportsStages.rejected, (state, action) => {
        state.loadingLengthReportsStages = false;
        state.errorLengthReportsStages = action.payload;
      });
    // --------------------------------------------------------
    builder
      .addCase(DeleteReportsStages.pending, (state, action) => {
        state.loadingdeletReportsStages = true;
        state.deletReportsStages = action.payload;
        state.errordeletReportsStages = null;
      })
      .addCase(DeleteReportsStages.fulfilled, (state, action) => {
        state.loadingdeletReportsStages = false;
        state.deletReportsStages = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteReportsStages.rejected, (state, action) => {
        state.loadingdeletReportsStages = false;
        state.errordeletReportsStages = action.payload;
      });

    // --------------------------------------------------------

    builder
      .addCase(GetReportStageByID.pending, (state, action) => {
        state.loadingReportsStagesById = true;
        state.ReportsStagesById = action.payload;
        state.errorReportsStagesById = null;
      })
      .addCase(GetReportStageByID.fulfilled, (state, action) => {
        state.loadingReportsStagesById = false;
        state.ReportsStagesById = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetReportStageByID.rejected, (state, action) => {
        state.loadingReportsStagesById = false;
        state.errorReportsStagesById = action.payload;
      });

    // --------------------------------------------------------

    builder
      .addCase(GetAllStagesByReportId.pending, (state, action) => {
        state.loadingReportsStagesDropDownList = true;
        state.ReportsStagesDropDownList = action.payload;
        state.errorReportsStagesDropDownList = null;
      })
      .addCase(GetAllStagesByReportId.fulfilled, (state, action) => {
        state.loadingReportsStagesDropDownList = false;
        state.ReportsStagesDropDownList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllStagesByReportId.rejected, (state, action) => {
        state.loadingReportsStagesDropDownList = false;
        state.errorReportsStagesDropDownList = action.payload;
      }); // --------------------------------------------------------

    builder
      .addCase(GetCurrentStageFromReport.pending, (state, action) => {
        state.loadingCurrentStage = true;
        state.CurrentStage = action.payload;
        state.errorCurrentStage = null;
      })
      .addCase(GetCurrentStageFromReport.fulfilled, (state, action) => {
        state.loadingCurrentStage = false;
        state.CurrentStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetCurrentStageFromReport.rejected, (state, action) => {
        state.loadingCurrentStage = false;
        state.errorCurrentStage = action.payload;
      });
      //----------------------------------------------------------------
      builder
      .addCase(GetListReportsStagesByAP_ApplicationInformationGUIDTotalTime.pending, (state, action) => {
        state.loadingCurrentStageInfo = true;
        state.CurrentStageInfo = action.payload;
        state.errorCurrentStageInfo = null;
      })
      .addCase(GetListReportsStagesByAP_ApplicationInformationGUIDTotalTime.fulfilled, (state, action) => {
        state.loadingCurrentStageInfo = false;
        state.CurrentStageInfo = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListReportsStagesByAP_ApplicationInformationGUIDTotalTime.rejected, (state, action) => {
        state.loadingCurrentStageInfo = false;
        state.errorCurrentStageInfo = action.payload;
      });
  },
});
export const { SetreportStageGuid } = Stages.actions;

export default Stages.reducer;
